import request from "./api";

class Entity {
    constructor({path, query}) {
        this.path = path;
        this.query = query;
    }

    list(type, query, sort, isCache) {
        query = query || this.query;
        return request(type, this.path, "GET", null, query, sort, isCache);
    }

    create(type, payload, query) {
        query = query || this.query;
        return request(type, this.path, "POST", payload, query);
    }

    update(type, id, payload, query) {
        const url = `${this.path}/${id}`;
        query = query || this.query;
        return request(type, url, "PATCH", payload, query);
    }

    get(type, id, query) {
        const url = `${this.path}/${id}`;
        query = query || this.query;
        return request(type, url, "GET", null, query);
    }
}

export const difficulty = new Entity({
    path: "/difficulty"
});

export const game = new Entity({
    path: "/game"
});

export const player_game_session = new Entity({
    path: "/player_game_session"
});

export const game_session = new Entity({
    path: "/game_session"
});

export const game_session_activity = new Entity({
    path: "/game_session_activity"
});

export const game_skill = new Entity({
    path: "/game_skill"
});

export const game_skill_position = new Entity({
    path: "/game_skill_position"
});

export const level = new Entity({
    path: "/level"
});

export const organization = new Entity({
    path: "/organization"
});

export const player = new Entity({
    path: "/player"
});

export const player_game_session_activity = new Entity({
    path: "/player_game_session_activity"
});

export const position = new Entity({
    path: "/position"
});

export const result = new Entity({
    path: "/result"
});

export const role = new Entity({
    path: "/role"
});

export const setting = new Entity({
    path: "/setting"
});

export const skill = new Entity({
    path: "/skill"
});

export const user = new Entity({
    path: "/user"
});

export const business_group = new Entity({
    path: "/business_group"
})



// WEBPACK FOOTER //
// ./src/modules/api/entities.js